{
  "enum": {
    "IxcBillingV1ChargeRejectionCode": {
      "BALANCE_HOLD_REJECTED": "Balance Hold Rejected",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcBillingV1ChargeStatus": {
      "APPROVAL": "Approval",
      "DONE": "Done",
      "REJECTED": "Rejected",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxcBillingV1ChargeQueryServiceChargeListFilterableFields": {
      "accountId": "Account",
      "chargeId": "Charge",
      "data": {
        "contra": {
          "accountId": "Contra Account"
        },
        "correspondentTransactionId": "Correspondent Transaction ID",
        "customerTransactionId": "Customer Transaction ID",
        "holdId": "Hold",
        "spec": {
          "category": "Category"
        }
      },
      "programId": "Program",
      "status": "Status"
    }
  },
  "oneOf": {
    "IxcBillingV1ChargeEventType": {
      "accepted": "Accepted",
      "approvalReply": "Approval Reply",
      "rejected": "Rejected",
      "requested": "Requested"
    },
    "IxcBillingV1ChargeEventTypeApprovalReplyType": {
      "reservation": "Reservation"
    }
  },
  "sortEnum": {
    "IxcBillingV1ChargeQueryServiceChargeListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}